export default "__VITE_PUBLIC_ASSET__cc00dfa2__"